import React from "react";

const ICON = (props) => {
  // Tomo los props
  const { prefix, icon, className } = props;

  // Renderizo
  return (
    <i
      className={`${prefix ? prefix : "fas"} fa-${icon} ${
        className ? className : ""
      }`}
    ></i>
  );
};

 export const ICON_LAST_PAGE = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-chevron-double-right"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708"
      />
      <path
        fill-rule="evenodd"
        d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708"
      />
    </svg>
  );
};

export const ICON_FIRST_PAGE = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-chevron-double-left"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
      />
      <path
        fill-rule="evenodd"
        d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
      />
    </svg>
  );
};

export const ICON_ACCUSED = (props) => <ICON {...props} icon="user-check" />;
export const ICON_ACTUATION = (props) => <ICON {...props} icon="file-alt" />;
export const ICON_ACTUATION_LIST = (props) => <ICON {...props} icon="copy" />;
export const ICON_ADD_PAYMENT = (props) => (
  <ICON {...props} icon="location-arrow" />
);
export const ICON_ANULATE = (props) => <ICON {...props} icon="times-circle" />;
export const ICON_APROVE = (props) => <ICON {...props} icon="check-circle" />;
export const ICON_BAN = (props) => <ICON {...props} icon="ban" />;
export const ICON_BELL = (props) => <ICON {...props} icon="bell" />;
export const ICON_BRANCH_PAYMENT = (props) => (
  <ICON {...props} icon="university" />
);
export const ICON_BRIEFCASE = (props) => <ICON {...props} icon="briefcase" />;
export const ICON_CALENDAR = (props) => <ICON {...props} icon="calendar" />;
export const ICON_CALENDAR_CHECK = (props) => (
  <ICON {...props} icon="calendar-check" />
);
export const ICON_CALENDAR_DAY = (props) => (
  <ICON {...props} icon="calendar-day" />
);
export const ICON_CALENDAR_WEEK = (props) => (
  <ICON {...props} icon="calendar-week" />
);
export const ICON_CANCEL = (props) => <ICON {...props} icon="times" />;
export const ICON_CHECK = (props) => <ICON {...props} icon="check-double" />;
export const ICON_CHECKOUT = (props) => (
  <ICON {...props} icon="file-invoice-dollar" />
);
export const ICON_CONFIG = (props) => <ICON {...props} icon="cog" />;
export const ICON_CLONE = (props) => <ICON {...props} icon="clone" />;
export const ICON_DASHBOARD = (props) => (
  <ICON {...props} icon="tachometer-alt" />
);
export const ICON_DELETE = (props) => <ICON {...props} icon="trash-alt" />;
export const ICON_DOWNLOAD = (props) => <ICON {...props} icon="download" />;
export const ICON_EDIT = (props) => <ICON {...props} icon="pencil-alt" />;
export const ICON_ENABLE = (props) => <ICON {...props} icon="power-off" />;
export const ICON_EYE = (props) => <ICON {...props} icon="eye" />;
export const ICON_FINALIZE = (props) => <ICON {...props} icon="tasks" />;
export const ICON_FOLDER = (props) => <ICON {...props} icon="folder-open" />;
export const ICON_HOME = (props) => <ICON {...props} icon="home" />;
export const ICON_INFO = (props) => <ICON {...props} icon="info-circle" />;
export const ICON_LAYERS = (props) => <ICON {...props} icon="feather" />;
export const ICON_LIST = (props) => <ICON {...props} icon="list-alt" />;
export const ICON_LOAD_MORE = (props) => <ICON {...props} icon="redo-alt" />;
export const ICON_MAIL = (props) => <ICON {...props} icon="envelope" />;
export const ICON_NEXT = (props) => (
  <ICON {...props} icon="arrow-circle-right" />
);
export const ICON_NEXT_ALT = (props) => (
  <ICON {...props} icon="chevron-right" />
);
export const ICON_NEW = (props) => <ICON {...props} icon="plus" />;
export const ICON_NO = (props) => <ICON {...props} icon="times-circle" />;
export const ICON_NOTIFICATION = (props) => <ICON {...props} icon="envelope" />;
export const ICON_OFIJU = (props) => <ICON {...props} icon="laptop-house" />;
export const ICON_ONLINE_PAYMENT = (props) => (
  <ICON {...props} icon="money-check" />
);
export const ICON_PAPERCLIP = (props) => <ICON {...props} icon="paperclip" />;
export const ICON_PEOPLE = (props) => <ICON {...props} icon="users" />;
export const ICON_PREV = (props) => (
  <ICON {...props} icon="arrow-circle-left" />
);
export const ICON_PREV_ALT = (props) => <ICON {...props} icon="chevron-left" />;
export const ICON_PRINT = (props) => <ICON {...props} icon="print" />;
export const ICON_PRIORITY = (props) => (
  <ICON {...props} icon="exclamation-triangle" />
);
export const ICON_RECEIPT = (props) => <ICON {...props} icon="receipt" />;
export const ICON_REDO = (props) => <ICON {...props} icon="redo" />;
export const ICON_REFRESH = (props) => <ICON {...props} icon="sync" />;
export const ICON_REFRESH_ALT = (props) => <ICON {...props} icon="sync-alt" />;
export const ICON_REMOVE = (props) => <ICON {...props} icon="eraser" />;
export const ICON_REPORT = (props) => <ICON {...props} icon="chart-area" />;
export const ICON_RESERVE = (props) => <ICON {...props} icon="eye-slash" />;
export const ICON_RESULT = (props) => <ICON {...props} icon="poll" />;
export const ICON_REVOKE = (props) => <ICON {...props} icon="window-close" />;
export const ICON_SAVE = (props) => <ICON {...props} icon="save" />;
export const ICON_SCHEDULING = (props) => <ICON {...props} icon="calendar" />;
export const ICON_SEARCH = (props) => <ICON {...props} icon="search" />;
export const ICON_SELECT = (props) => <ICON {...props} icon="check" />;
export const ICON_SHARE = (props) => <ICON {...props} icon="share-square" />;
export const ICON_SHORTCUT = (props) => (
  <ICON {...props} icon="external-link-alt" />
);
export const ICON_SIGN_OUT = (props) => <ICON {...props} icon="sign-out-alt" />;
export const ICON_TABLE = (props) => <ICON {...props} icon="table" />;
export const ICON_TREATMENT = (props) => <ICON {...props} icon="tools" />;
export const ICON_TUTORIAL = (props) => (
  <ICON {...props} icon="chalkboard-teacher" />
);
export const ICON_UNDO = (props) => <ICON {...props} icon="undo" />;
export const ICON_UNRESERVE = (props) => <ICON {...props} icon="eye" />;
export const ICON_VIDEO = (props) => <ICON {...props} icon="video" />;
export const ICON_YES = (props) => <ICON {...props} icon="check-circle" />;
